// components/ServiceForm/ServiceForm.styles.ts
import { SxProps, Theme } from '@mui/material/styles';

export const serviceFormStyles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  },
  
  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  
  label: {
    fontWeight: 500,
    color: 'text.primary',
    mb: 1,
  },
  
  textField: {
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: 'primary.main',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'primary.main',
      },
    },
  },
  
  buttonContainer: {
    display: 'flex',
    gap: 1,
    pt: 2,
  },
  
  submitButton: {
    backgroundColor: 'primary.main',
    '&:hover': {
      backgroundColor: 'primary.dark',
    },
  },
  
  cancelButton: {
    borderColor: 'grey.400',
    color: 'text.secondary',
    '&:hover': {
      borderColor: 'grey.600',
      backgroundColor: 'grey.50',
    },
  },
};